import { FileTypeEnum } from "../enums/fileTypeEnum";
import { getLastSplittedStringItem } from "../helpers/stringHelper";
import { IMapper } from "../../interfaces/IMapper";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { tryDecodeUriComponent } from "../../../../utilities/EncodeDecode";
import dayjs from 'dayjs';

export class RecentFilesMapper implements IMapper<IStoreItem[]> {
    constructor(private languageStrings: any, private cannotBeRemoved: boolean = false) { }

    map(data: any, isCustomEntry?: boolean): IStoreItem[] {
        return data.filter(item => item).map(item => <IStoreItem>({
            driveId: item?.parentReference?.driveId,
            name: item?.name,
            extension: getLastSplittedStringItem(item?.name, /[.]+/),
            folderId: item?.parentReference?.id,
            itemId: item?.id,
            fileType: FileTypeEnum.file,
            filePath: `[${this.languageStrings.Files}] ${tryDecodeUriComponent(item.webUrl)}`,
            // datePinned: item?.lastModifiedDateTime?.length && dayjs(item.lastModifiedDateTime).toDate(),
            datePinned: isCustomEntry ? new Date() : (item?.lastModifiedDateTime?.length && dayjs(item.lastModifiedDateTime).toDate()),
            lastModifiedDateTime: item?.lastModifiedDateTime,
            modifiedBy: item?.lastModifiedBy?.user?.displayName,
            cannotBeRemoved: this.cannotBeRemoved,
            sharedByName: item?.shared?.sharedBy?.user?.displayName,
            sharedByEmail: item?.shared?.sharedBy?.user?.email,
            sharedDateTime: item?.shared?.sharedDateTime,
        }));
    }
}
